// `drink` , the bar item. Pour SIZES (single/double/bottle) are option-group
// options, each with its own price + volume (Slice 2/5), not stored here. This
// profile carries only the drink's scalar attributes: ABV, age gate, happy-hour
// delta. doc 38 Part 1.

import { z } from 'zod';

import type { ItemKindDefinition } from './registry-types';
import type { DrinkProfile } from './types';

export const DrinkProfileSchema = z.object({
  abv: z.number().min(0).max(100).optional(),
  age_restricted: z.boolean().optional(),
  happy_hour_price_delta: z.number().optional(),
  default_pour_id: z.string().optional(),
});

export const drinkKind: ItemKindDefinition<DrinkProfile> = {
  id: 'drink',
  label: 'Drink',
  noun: 'drink',
  description: 'A bar drink, optionally sold by pour size and age-restricted.',
  defaultPricingMode: 'per_pour',
  allowedPricingModes: ['per_pour', 'flat'],
  schema: DrinkProfileSchema as unknown as z.ZodType<DrinkProfile>,
  defaultProfile: () => ({}),
};
